import { ceil, floor, random } from '../util/math/Math'

export default function getRandomInteger(min: number, max: number): number {
  const minCeiled = ceil(min)
  const maxFloored = floor(max)
  // The maximum is exclusive and the minimum is inclusive
  return floor(random() * (maxFloored - minCeiled) + minCeiled)
}
